import { Box } from '@chakra-ui/react'
import styled from '@emotion/styled'

import theme from 'styles/theme'

export const DateTimePickerButton = styled('button', {
  shouldForwardProp: (prop) => !['isFocused', 'isDisabled'].includes(prop.toString()),
})<{
  isFocused: boolean
  isDisabled?: boolean
}>`
  display: flex;
  align-items: center;

  padding: 8px 14px;

  opacity: ${({ isDisabled }) => (isDisabled ? 0.5 : 1)};
  pointer-events: ${({ isDisabled }) => (isDisabled ? 'none' : 'all')};
  border: ${({ isFocused }) => `1px solid ${isFocused ? theme.token.var('colors.green.a100') : 'transparent'}`};
  border-radius: ${theme.token.var('borderRadius.small')};
  background-color: ${theme.token.var('colors.white')};
  transition: border-color 0.3s ease-in-out, opacity 0.3s ease-in-out;

  text-align: left;

  &:hover {
    border: 1px solid ${theme.token.var('colors.green.a100')};
  }
`

export const DateTimePickerButtonIcon = styled.img`
  margin-right: 14px;
  flex-grow: 0;
`

export const DateTimePickerButtonContent = styled(Box)`
  margin-right: auto;
`
